import { z } from '@hono/zod-openapi';
const idStringSchema = z.string().trim().min(1);
const isoDateStringSchema = z.string().datetime();
export const largeTradeMarketSectionSchema = z.enum(['moneyline', 'spread', 'total_goals', 'prop']);
export const largeTradeSideSchema = z.enum(['buy', 'sell', 'unknown']);
export const largeTradeSourceSchema = z.enum(['polymarket_data_api_trades']);
export const largeTradeIngestionItemSchema = z.object({
    sourceTradeId: idStringSchema,
    source: largeTradeSourceSchema,
    polymarketEventId: idStringSchema,
    polymarketMarketId: idStringSchema,
    polymarketOutcomeId: idStringSchema.nullable().optional(),
    clobTokenId: idStringSchema.nullable().optional(),
    radarEventId: idStringSchema.nullable().optional(),
    marketSection: largeTradeMarketSectionSchema.nullable().optional(),
    lineValue: idStringSchema.nullable().optional(),
    outcomeLabel: idStringSchema,
    side: largeTradeSideSchema,
    price: z.number().finite().gt(0).lt(1),
    size: z.number().finite().positive(),
    notionalUsd: z.number().finite().positive(),
    participantId: idStringSchema.nullable(),
    occurredAt: isoDateStringSchema,
    rawPayload: z.unknown(),
});
export const largeTradeIngestionBatchSchema = z.object({
    trades: z.array(largeTradeIngestionItemSchema).min(1).max(500),
});
const csvParamSchema = z
    .string()
    .trim()
    .transform(value => value.split(',').map(item => item.trim()).filter(Boolean))
    .pipe(z.array(idStringSchema).min(1));
export const largeTradeReadQuerySchema = z.object({
    eventIds: csvParamSchema.optional(),
    polymarketEventId: idStringSchema.optional(),
    polymarketMarketId: idStringSchema.optional(),
    polymarketOutcomeId: idStringSchema.optional(),
    clobTokenId: idStringSchema.optional(),
    marketSection: largeTradeMarketSectionSchema.optional(),
    lineValue: idStringSchema.optional(),
    minNotionalUsd: z.coerce.number().finite().positive().optional(),
    windowMinutes: z.coerce.number().int().positive().max(10080).optional(),
    limit: z.coerce.number().int().positive().max(200).optional(),
});
export const largeTradeIngestionResponseSchema = z.object({
    accepted: z.number().int().nonnegative(),
    deduplicated: z.number().int().nonnegative(),
});
export const radarLargeTradeOrderSchema = z.object({
    id: idStringSchema,
    participantId: idStringSchema.nullable(),
    action: z.enum(['buy', 'sell']),
    outcomeLabel: idStringSchema,
    volumeUsd: z.number().finite().nonnegative(),
    entryPriceCents: z.number().int().min(0).max(100),
    expectedValueBps: z.number().int().nullable(),
    timestamp: isoDateStringSchema,
    source: largeTradeSourceSchema,
    polymarketEventId: idStringSchema,
    polymarketMarketId: idStringSchema,
    polymarketOutcomeId: idStringSchema.nullable(),
    clobTokenId: idStringSchema.nullable(),
    marketSection: largeTradeMarketSectionSchema.nullable(),
    lineValue: idStringSchema.nullable(),
});
export const radarLargeTradeSummarySchema = z.object({
    count: z.number().int().nonnegative(),
    totalNotionalUsd: z.number().finite().nonnegative(),
    latestTradeAt: isoDateStringSchema.nullable(),
    marketSection: largeTradeMarketSectionSchema.nullable(),
    lineValue: idStringSchema.nullable(),
    outcomeLabel: idStringSchema.nullable(),
});
